<template>
  <div>
    <div v-if="!selectedProduct">
      <v-layout wrap align-center>
        <v-flex d-flex>
          <h3 class="primary-color text-center">
            {{ mensagemListaGeradores }}
          </h3>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center class="my-3">
        <v-flex xs12 sm10 xl8 offset-sm1 offset-xl2>
          <v-card flat class="elevation-0 grey lighten-5">
            <v-container grid-list-sm fluid>
              <v-layout row wrap>
                <v-flex v-for="(product, index) in geradores" :key="index" xs12 sm4 md3>
                  <Product :product="product" />
                  <v-layout row wrap style="margin-top: -100px; margin-bottom: 100px">
                    <v-flex xs12 xl6 class="pb-0 text-xs-center">
                      <v-btn block outline color="#021746" class="back-button" @click="openOnNewTab(product.url)">VER DETALHES </v-btn>
                    </v-flex>
                    <v-flex xs12 xl6 class="text-xs-center">
                      <v-btn block color="#0083CA" class="white--text" @click="selectProduct(product)">SELECIONAR </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
      <div class="text-center">
        <v-btn outline color="#021746" @click="previousStep()" class="back-button">VOLTAR</v-btn>
      </div>
    </div>
    <div v-else>
      <v-form ref="form" v-model="valid" v-on:submit.prevent="send">
        <v-layout row wrap class="my-3">
          <v-flex xs12 sm6 md5 offset-sm2>
            <h3 class="primary-text">{{ selectedProduct.Titulo }}</h3>
            <h4 class="generator-description">{{ selectedProduct.PRD_DESCRICAO }}</h4>
            <template v-if="type == 'create'">
              <v-divider class="mr-5 mt-3 mb-4"></v-divider>
              <!-- <h4 class="topic">Informações gerais</h4> -->
              <!-- <div class="general-information" v-html="selectedProduct.DescricaoTecnica"></div> -->
              <v-layout row wrap>
                <v-flex>
                  <!-- <v-btn outline color="#021746" @click="openSelectedProductOnNewTab()" class="back-button ml-0">VER
                  DETALHES
                </v-btn> -->
                  <v-btn color="#50BED3" class="white--text ml-auto" @click="deselectProduct()">TROCAR GERADOR </v-btn>
                </v-flex>
              </v-layout>
            </template>
          </v-flex>
          <v-flex xs12 sm3 md2>
            <v-img :src="getImagemProduto"></v-img>
            <div style="display: flex; flex-direction: column; justify-content: center; justify-items: center; margin: 20px">
              <v-btn color="#0083CA" class="white--text" @click="personalizeProduct(selectedProduct)"
                ><v-icon color="#fff" x-small class="mr-3">palette</v-icon> PERSONALIZAR</v-btn
              >
            </div>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 sm10 md8 offset-sm2>
            <v-divider class="mt-3 mb-4"></v-divider>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 sm10 md8 offset-sm2>
            <h4 class="topic">Investimento</h4>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 sm10 md8 offset-sm2>
            <v-layout>
              <v-flex xs12 sm6>
                <p class="info-label-text">Valor (Unit Revenda)</p>
                <h2 class="primary-text">
                  {{
                    selectedProduct.Preco
                      | currency('R$', 2, {
                        thousandsSeparator: '.',
                        decimalSeparator: ',',
                        spaceBetweenAmountAndSymbol: true,
                      })
                  }}
                </h2>
                <v-layout>
                  <v-flex xs6 sm8 md6>
                    <v-text-field
                      class="info-label-text mt-4"
                      label="Valor venda direta"
                      v-money="money"
                      prefix="R$"
                      v-model.lazy="projeto.valorEUP"
                      min="0"
                      :rules="valueRules"
                      required
                      @blur="recalcularParcelas"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 sm10 md8 offset-sm2>
            <v-divider class="mt-3 mb-4"></v-divider>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex column wrap>
            <div v-if="type == 'create'" class="text-center">
              <v-btn outline color="#021746" @click="deselectProduct()" class="back-button">VOLTAR</v-btn>
              <v-btn :disabled="loading" color="#0083CA" min-width="200px" class="white--text" @click="finishSelectGenerator()"
                >SELECIONAR GERADOR
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-form>
    </div>
  </div>
</template>

<script>
import Vue2Filters from 'vue2-filters'
import Product from '../partials/Product'
import { mapGetters, mapActions } from 'vuex'
import { VMoney } from 'v-money'

export default {
  name: 'ListCompatibleGenerators',
  components: { Product },
  props: ['type', 'projectId'],
  directives: { money: VMoney },
  methods: {
    ...mapActions([
      'selectProduct',
      'deselectProduct',
      'nextStep',
      'previousStep',
      'getValoresParcelamentoCartao',
      'getValoresParcelamentoSolAgora',
      'loadContatoRevenda',
    ]),
    async recalcularParcelas() {
      try {
        this.loading = true
        await this.loadContatoRevenda()
        await this.$store.dispatch('getValoresParcelamentoSolAgora', {
          cnpj: this.projeto.contatoRevenda.cnpj,
          valor: parseFloat(this.projeto.valorEUP.replace('R$', '').replaceAll('.', '').replace(',', '.')),
          cpfCliente: this.projeto.cliente.documento,
          valorConta: this.projeto.contas
            .map((x) => parseFloat(x.valor.replace('R$', '').replaceAll('.', '').replace(',', '.')))
            .reduce((acc, valor) => acc + valor, 0),
        })
        await this.$store.dispatch('getValoresParcelamentoCartao', {
          codigoProduto: this.projeto.produto,
          valor: parseFloat(this.projeto.valorEUP.replace('R$ ', '').replace('.', '').replace(',', '.')),
        })
      } finally {
        this.loading = false
      }
    },
    async finishSelectGenerator() {
      if (this.$refs.form.validate()) {
        if (this.projeto.cliente.parcelasCartao.length == 0) await this.recalcularParcelas()
        this.nextStep()
      }
    },
    openOnNewTab(url) {
      let route = this.$router.resolve({ path: url })
      // let route = this.$router.resolve(url); // This also works.
      window.open(route.href, '_blank')
    },
    openSelectedProductOnNewTab() {
      const element = this.selectedProduct
      let produto = {}
      produto.id = element.PRD_CODIGO
      produto.code = element.PRD_CODIGO + '-' + element.PRD_CODIGODV
      produto.name = element.PSG_DESCRICAO + ' ' + element.PGR_DESCRICAO
      produto.state = 'PR'
      produto.img = element.PRD_CAMINHO
      produto.description = element.PRD_DESCRICAO

      const productDesc =
        produto.name
          .replace(/\s+/g, '-')
          .replace(/[^a-zA-Z0-9záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ-]/g, '')
          .toLowerCase() +
        '-' +
        element.PRD_DESCRICAO.trim()
          .replace(/\s+/g, '-')
          .replace(/[^a-zA-Z0-9záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ-]/g, '')
          .toLowerCase()

      const url = '/loja/produto/' + produto.code + '/' + productDesc
      this.openOnNewTab(url)
    },
    currencyToNumber(value) {
      return Number(value.replace(/[d,.?!]+/g, '')) / 100
    },
    personalizeProduct(product) {
      const personalizacaoExistente = JSON.parse(localStorage.getItem('geradoresPeronalizados'))

      if (!personalizacaoExistente || personalizacaoExistente.length === 0) {
        this.$router.push(`/loja/personalizacao-gerador?prod=${product.PRD_CODIGO}&proj=${this.projectId}`)
        return
      }

      swal({
        title: 'Personalização de gerador',
        text: 'Já existe uma personalização em andamento e ela será descartada.\n\nDeseja realmente continuar?',
        buttons: ['Não', 'Sim'],
        dangerMode: true,
      }).then((novo) => {
        if (novo) {
          this.$router.push(`/loja/personalizacao-gerador?prod=${product.PRD_CODIGO}&proj=${this.projectId}`)
        }
      })
    },
  },
  mixins: [Vue2Filters.mixin],
  computed: {
    ...mapGetters(['geradores', 'selectedProduct', 'projeto', 'mensagemListaGeradores']),
    getImagemProduto() {
      try {
        return this.selectedProduct.Imagens[0].ArqUrlHires
      } catch (error) {
        return ''
      }
    },

    valorFrete() {
      if (this.projeto.transportadora && this.projeto.transportadora.Taxa) return this.projeto.transportadora.Taxa

      return 0
    },
  },
  data() {
    return {
      loading: false,
      infoImage: require('./icons/info.svg'),
      valid: false,
      valueRules: [
        (v) => !!v || 'Valor é obrigatório',
        (v) =>
          (this.selectedProduct != null && this.currencyToNumber(v) >= Math.round((this.selectedProduct.Preco + this.valorFrete) * 100) / 100) ||
          'Valor deve ser maior que o valor unitário do produto',
        (v) =>
          (this.selectedProduct != null && this.currencyToNumber(v) <= Math.round((this.selectedProduct.PrecoEUP + this.valorFrete) * 100) / 100) ||
          'Valor deve ser menor que o valor sugerido: ' +
            (this.selectedProduct != null
              ? (this.selectedProduct.PrecoEUP + this.valorFrete).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
              : '0,00'),
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
    }
  },
}
</script>

<style scoped>
.info-label-text {
  color: #021746;
  font-size: 15px;
}

.info-value-text {
  color: #0083ca;
  font-size: 15px;
  font-weight: bold;
}
</style>
